import React from 'react'
import { withIcon } from '../../withIcon'

function MicOffOutlineIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 23">
      <path d="M3 3L21 21M9 5C9 4.20435 9.31607 3.44129 9.87868 2.87868C10.4413 2.31607 11.2044 2 12 2C12.7956 2 13.5587 2.31607 14.1213 2.87868C14.6839 3.44129 15 4.20435 15 5V10C15 10.2962 14.9562 10.5907 14.87 10.874M12.87 12.874C12.4217 13.0099 11.9478 13.0388 11.4862 12.9586C11.0247 12.8784 10.5884 12.6912 10.2122 12.412C9.83599 12.1328 9.53041 11.7694 9.31992 11.3509C9.10942 10.9324 8.99986 10.4705 9 10.002V9.002M5 10C4.99978 11.2633 5.34146 12.5032 5.98881 13.5881C6.63616 14.673 7.56505 15.5624 8.67697 16.1622C9.78888 16.7619 11.0424 17.0495 12.3045 16.9946C13.5667 16.9396 14.7904 16.5441 15.846 15.85M17.846 13.85C18.5998 12.7077 19.0005 11.3686 18.998 10M8 21H16M12 17V21" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    </svg>
  )
}

export default withIcon(MicOffOutlineIcon)
